//import React from 'react';
import { sbaas } from '@/config';
//import { RedoOutlined } from '@ant-design/icons';
//import { Header } from 'antd/lib/layout/layout';
import React, { Fragment, useState, useEffect } from 'react';
//import { Layer, Stage, Line } from 'react-konva';
import { RouteComponentProps, useHistory } from 'react-router-dom';
// import locale from 'antd/lib/date-picker/locale/id_ID';
import 'moment/locale/id';
import idID from 'antd/lib/locale/id_ID';
//import { Button, Checkbox, Form, Input, Modal, Radio, Row, Select } from 'antd';
import {
  Row,
  Form,
  Input,
  Button,
  Checkbox,
  message,
  DatePicker,
  Space,
  DatePickerProps,
  Select,
  ConfigProvider,
} from 'antd';
import moment from 'moment';
import UploadInput from '@/components/custom/spp/UploadInput';
import { Helmet } from 'react-helmet';

const { Option } = Select;
type LayoutType = Parameters<typeof Form>[0]['layout'];

window.appKey = String(process.env.REACT_APP_COUNTLY_APP_KEY);

const Spp = ({  }: RouteComponentProps) => {
  const [isLoading] = useState(false);
  const [formLayout, setFormLayout] = useState<LayoutType>('vertical');
  const [custName, setCustName] = useState<any>(null);
  const [phoneNo, setPhoneNo] = useState<any>(null);
  // const [age, setAge] = useState<any>(null);
  const [dates, setDates] = useState<any>(null);
  const [idNo, setIdNo] = useState<any>(null);
  const [schoolName, setSchoolName] = useState<any>(null);
  const [email, setEmail] = useState<any>(null);
  const [otp, setOtp] = useState<any>(null);
  const [otpId, setOtpId] = useState<any>(null);
  const [, setAnswerEmail] = useState<any>(null);
  const [storeCode, setStoreCode] = useState<any>('');
  const [ecCode, setEcCode] = useState<any>('');
  const [device, setDevice] = useState<any>(null);
  const [image, setImage] = useState<File>();
  const [disablingSubmit, setDisablingSubmit] = useState(true);
  const [disablingSendOtp, setDisablingSendOtp] = useState(false);
  const [isLoadingOtp, setIsLoadingOtp] = useState(false);

  //const [readyToSubmit, setreadyToSubmit] = useState(false);
  const [isLoadingKirim, setIsLoadingKirim] = useState(false);
  const [isPrivacy, setIsPrivacy] = useState(false);
  const [isPromotion, setIsPromotion] = useState(false);

  const [form] = Form.useForm();
  const history = useHistory();
  // const { Option } = Select;

  const [arrDeviceOptions, setArrDeviceOptions] = useState(['']);
  // for (let i = 6; i <= 30; i++) {
  //   arrAgeOptions.push({ value: i.toString(), text: i.toString() });
  // }

  //var idLocale = require('moment/locale/id');

  const onChangeDate: DatePickerProps['onChange'] = date => {
    let dateForm;
    if (date) {
      dateForm = date.format('MM/DD/YYYY');
    }
    setDates(dateForm);
  };

  const disabledDate: DatePickerProps['disabledDate'] = current => {
    // Can not select days before today and today
    let minDate = moment().subtract(6, 'years');
    let maxDate = moment().subtract(21, 'years');
    return current < maxDate || current > minDate;
  };

  const onFormLayoutChange = ({ layout }: { layout: LayoutType }) => {
    setFormLayout(layout);
  };

  // const changeTitle = () => {
  //   document.title = 'Student Purchase Program';
  // }

  useEffect(() => {
    document.title = 'Student Purchase Program';
  });

  // Customer Name
  const validateCustName = (inputText: String) => {
    if (inputText === undefined || inputText === null) {
      return true;
    }
    if (
      (inputText.trim().length === 1 && inputText.trim()[0] === "'") ||
      (inputText.trim().length >= 1 &&
        inputText.trim()[0] === "'" &&
        inputText.trim()[1] === "'") ||
      inputText.trim().length === 0
    ) {
      return false;
    }

    var custNameFormat = /^([a-zA-Z0-9' ]{1,50})$/;
    if (custNameFormat.test(String(inputText.toLowerCase()))) {
      return true;
    } else {
      return false;
    }
  };
  // Customer Telephone Number
  const validatePhoneNumber = (inputText: String) => {
    if (inputText === undefined || inputText === null) {
      return true;
    }

    var phoneNumberFormat = /^([0-9]{10,15})$/;
    if (phoneNumberFormat.test(String(inputText.toLowerCase()))) {
      return true;
    } else {
      return false;
    }
  };
  //Customer ID Number
  const validateIdNumber = (inputText: String) => {
    if (inputText === undefined || inputText === null) {
      return true;
    }

    var idNumberFormat = /^([a-zA-Z0-9]{1,})$/;
    if (idNumberFormat.test(String(inputText.toLowerCase()))) {
      return true;
    } else {
      return false;
    }
  };

  // const validateAge = (select: string) => {
  //   if (select < '4' || select > '40') {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // };

  //Customer School
  const validateSchool = (inputText: String) => {
    if (inputText === undefined || inputText === null) {
      return true;
    }
    if (
      (inputText.trim().length === 1 && inputText.trim()[0] === "'") ||
      (inputText.trim().length >= 1 &&
        inputText.trim()[0] === "'" &&
        inputText.trim()[1] === "'") ||
      inputText.trim().length === 0
    ) {
      return false;
    }

    var schoolNameFormat = /^([a-zA-Z0-9' ]{1,})$/;
    if (schoolNameFormat.test(String(inputText.toLowerCase()))) {
      return true;
    } else {
      return false;
    }
  };

  const listDevice = async () => {
    await sbaas
      .script('spp_get_promo_gadget_list')
      .get({})
      .then(res => {
        if (res.data) {
          setArrDeviceOptions(res.data.response);
          // localStorage.setItem('session', JSON.stringify(arrDeviceOptions))
        } else {
        }
      });
  };

  const onClickSendOtp = async () => {
    let formData = new FormData();
    formData.append('name', custName);
    formData.append('email', email);

    try {
      await sbaas
        .script('spp-push-email-otp')
        .post({
          body: {
            name: custName,
            email: email,
          },
        })
        .then(res => {
          setOtpId(res.data.data.otpid);
          setAnswerEmail(email);
        });
    } catch (error) {}
    setSeconds(29);
    setDisablingSendOtp(true);
    setIsLoadingOtp(true);
    setTimeout(() => {
      setDisablingSendOtp(false);
      setIsLoadingOtp(false);
    }, 30000);
  };

  const [seconds, setSeconds] = useState<any>(null);
  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });
  //Upload Image

  //Email
  const validateEmail = (inputText: String) => {
    if (inputText === undefined || inputText === null) {
      return true;
    }
    // eslint-disable-next-line
    var mailFormat = /\w+(?:[.-]\w+)*@\w+(?:[.-]\w+)*(?:\.[a-zA-Z]{2,4})+$/;
    // var mailFormat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/;
    if (
      mailFormat.test(String(inputText.toLowerCase())) &&
      inputText.length <= 50
    ) {
      return true;
    } else {
      return false;
    }
  };
  const validateOtp = (inputText: String) => {
    if (inputText === undefined || inputText === null) {
      return true;
    }

    var phoneNumberFormat = /^([0-9]{4,4})$/;
    if (phoneNumberFormat.test(String(inputText.toLowerCase()))) {
      return true;
    } else {
      return false;
    }
  };

  const validateSendOtp = (mEmail: String) => {
    if (
      mEmail === null ||
      mEmail === '' ||
      mEmail === undefined ||
      !validateEmail(mEmail)
    ) {
      return false;
    } else {
      return true;
    }
  };

  //Validate Store Code
  const validateStoreCode = (inputText: String) => {
    if (
      inputText === undefined ||
      inputText === null ||
      inputText.length === 0
    ) {
      return true;
    }

    if (
      (inputText.trim().length === 1 && inputText.trim()[0] === "'") ||
      (inputText.trim().length >= 1 &&
        inputText.trim()[0] === "'" &&
        inputText.trim()[1] === "'")
    ) {
      return false;
    }

    var custNameFormat = /^([-_a-zA-Z0-9' ]{1,50})$/;
    if (custNameFormat.test(String(inputText.toLowerCase()))) {
      return true;
    } else {
      return false;
    }
  };
  //Validate Ec Code
  const validateEcCode = (inputText: String) => {
    if (
      inputText === undefined ||
      inputText === null ||
      inputText.length === 0
    ) {
      return true;
    }

    if (
      (inputText.trim().length === 1 && inputText.trim()[0] === "'") ||
      (inputText.trim().length >= 1 &&
        inputText.trim()[0] === "'" &&
        inputText.trim()[1] === "'")
    ) {
      return false;
    }

    var custNameFormat = /^([a-zA-Z0-9'_ \-]{1,50})$/;
    if (custNameFormat.test(String(inputText.toLowerCase()))) {
      return true;
    } else {
      return false;
    }
  };

  function onChangePrivacy(checkedValues: any) {
    setIsPrivacy(true);
    if (checkedValues.length === 0) {
      setIsPrivacy(false);
    }
  }

  function onChangePromotion(checkedValues: any) {
    setIsPromotion(true);
    if (checkedValues.length === 0) {
      setIsPromotion(false);
    }
  }

  const onClickSubmit = async () => {
    if (image !== undefined) {
      let formData = new FormData();
      formData.append('name', custName);
      formData.append('id_number', idNo);
      formData.append('school_name', schoolName);
      formData.append('phone_number', phoneNo);
      formData.append('dob', dates);
      formData.append('email', email);
      formData.append('store_code', storeCode);
      formData.append('ec_code', ecCode);
      formData.append('is_agree_send_promo', isPromotion.toString());
      formData.append('selected_device', device);
      formData.append('filename', image);
      formData.append('otpId', otpId);
      formData.append('otpCode', otp);

      setDisablingSubmit(true);
      setIsLoadingKirim(true);
      try {
        await sbaas
          .script('spp_post_data_form')
          .post({
            body: formData,
          })
          .then(res => {
            // window.location.reload();

            // Redirect to voucher result page if success
            if (res.data.message == 'INVALID OTP') {
              setDisablingSubmit(false);
              setIsLoadingKirim(false);
              message.error('Kode OTP tidak valid');
              return;
            }

            if (res.data.response[0].status === 'SUCCESS') {
              const onSuccess = () => {
                history.push('/spp/result_voucher/', {
                  data: res.data.response[0],
                } as { data: JSON });
              };
              sendToEmail(res.data.response[0], onSuccess);
            } else if (res.data.response[0].status === 'FAILED') {
              message.error(res.data.response[0].message);
              setDisablingSubmit(false);
              setIsLoadingKirim(false);
            }
          });
      } catch (error) {
        setDisablingSubmit(false);
        setIsLoadingKirim(false);
      }
    }
  };

  const sendToEmail = async function(json: JSON, successCallback: any) {
    try {
      await sbaas
        .script('spp-push-email-voucher-code')
        .post({
          body: {
            name: json['name'],
            phone: json['phone_number'],
            dob: json['dob'],
            idNumber: json['id_number'],
            schoolName: json['school_name'],
            email: json['email'],
            vcode: json['voucher_code'],
            expiredDate: json['expired_date'],
            storeName: json['store_name'],
            selectedDevice: json['selected_device'],
          },
        })
        .then(successCallback());
    } catch (error) {}
  };

  const onClickContactService = () => {
    history.replace('/contact-service');
  };

  useEffect(() => {
    if (
      // '==' operator treats undefined and null as the same
      custName == null ||
      idNo == null ||
      phoneNo == null ||
      dates == null ||
      device == null ||
      schoolName == null ||
      email == null ||
      otp == null ||
      image == undefined ||
      image == null ||
      !validateCustName(custName) ||
      !validateEmail(email) ||
      !validatePhoneNumber(phoneNo) ||
      !validateIdNumber(idNo) ||
      !validateSchool(schoolName) ||
      !validateOtp(otp) ||
      email.length > 50 ||
      !isPrivacy
      //TestingPurpose
      //!isPromotion
    ) {
      setDisablingSubmit(true);
    } else {
      setDisablingSubmit(false);
    }
    if (validateSendOtp(email)) {
      !isLoadingOtp ? setDisablingSendOtp(false) : setDisablingSendOtp(true);
    } else {
      setDisablingSendOtp(true);
    }
  });

  const [finishStatus, setfinishStatus] = useState(false);

  const onBackButtonEvent = (e: any) => {
    e.preventDefault();
    if (!finishStatus) {
      if (window.confirm('Changes you made may not be saved.')) {
        setfinishStatus(true);
        // your logic
        //history.push('/');
      } else {
        window.history.pushState(null, 'null', window.location.pathname);
        setfinishStatus(false);
      }
    }
  };

  useEffect(() => {
    window.history.pushState(null, 'null', window.location.pathname);
    window.addEventListener('popstate', onBackButtonEvent);
    return () => {
      window.removeEventListener('popstate', onBackButtonEvent);
    };
  }, []);

  function initialPageLoad() {
    document.title = 'Student Purchase Program';
    listDevice();
  }

  useEffect(() => {
    document.title = 'Student Purchase Program';
    initialPageLoad();
  }, []);

  return isLoading ? (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <div className="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  ) : (
    <Fragment>
      {/* <Header style={{ backgroundColor: 'white' }} className="header">
        <div className="logo" />
      </Header> */}

      <Helmet>
        <script type="text/javascript">
          {`
      var Countly = Countly || {};
      Countly.q = Countly.q || [];
      
      Countly.debug = true;
      Countly.app_key = window.appKey;
      Countly.url = "https://srincountly.srinapps.com";
      
      Countly.q.push(['track_pageview', '/spp']);
      Countly.q.push(['track_sessions']);
      Countly.q.push(['add_event',{
        key:"action_open_spp", 
      }]);
      
      // Load Countly script asynchronously
      (function() {
      var cly = document.createElement('script'); 
      cly.type = 'text/javascript';
      cly.async = true;
      // Enter url of script here (see below for other option)
      cly.src = 'https://cdn.jsdelivr.net/npm/countly-sdk-web@latest/lib/countly.min.js';
      cly.onload = function(){Countly.init()};
      var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(cly, s);
      })();
    `}
        </script>
      </Helmet>

      <Row>
        {/* <div className="spp-header-banner"></div> */}
        <img
          src={require('./StudentOfferBanner.jpg')}
          className="spp-header-banner"
        />
        <div className="submit-form-content">
          <Form
            layout={formLayout}
            form={form}
            initialValues={{ layout: formLayout }}
            onValuesChange={onFormLayoutChange}
          >
            <div className="fieldset">
              <h1>
                <span>Diisi oleh Pelajar</span>
              </h1>
              <h2 style={{ fontWeight: 'bold' }}>Data Pelajar</h2>
              <Form.Item
                label={
                  <span style={{ fontWeight: 'bold' }}>
                    Nama Lengkap<span style={{ color: '#FF2020' }}>*</span>
                  </span>
                }
                help={
                  validateCustName(custName) ? (
                    ''
                  ) : (
                    <span style={{ color: '#FF2020', fontSize: '10px' }}>
                      Nama tidak valid. Masukkan format nama yang benar tanpa
                      mengandung simbol dan maksimal 50 karakter.
                    </span>
                  )
                }
              >
                <Input
                  placeholder=""
                  onChange={e => setCustName(e.target.value)}
                />
              </Form.Item>
              {/* --No HP */}
              <Form.Item
                label={
                  <span style={{ fontWeight: 'bold' }}>
                    Nomor Telepon
                    <span style={{ color: '#FF2020' }}>*</span>
                  </span>
                }
                help={
                  validatePhoneNumber(phoneNo) ? (
                    ''
                  ) : (
                    <span style={{ color: '#FF2020', fontSize: '10px' }}>
                      Nomor tidak valid, masukkan minimal 10 angka dan maksimal
                      15 angka.
                    </span>
                  )
                }
              >
                <Input
                  placeholder=""
                  onChange={e => setPhoneNo(e.target.value)}
                />
              </Form.Item>

              {/* Umur */}
              <Form.Item
                label={
                  <span style={{ fontWeight: 'bold' }}>
                    Tanggal Lahir
                    <span style={{ color: '#FF2020' }}>*</span>
                  </span>
                }
                // help={
                //   validateAge(age) ? (
                //     ''
                //   ) : (
                //     <span style={{ color: '#FF2020', fontSize: '10px' }}></span>
                //   )
                // }
              >
                {/* <Select style={{ width: 120 }} onChange={e => setAge(e)}>
                {arrAgeOptions.map((option, index) => (
                  <Option key={index} value={option.value}>
                    {option.text}
                  </Option>
                ))}
              </Select>
              <span style={{ marginLeft: '5px' }}>Tahun</span> */}
                <Space direction="vertical">
                  <ConfigProvider locale={idID}>
                    <DatePicker
                      onChange={onChangeDate}
                      disabledDate={disabledDate}
                    />
                  </ConfigProvider>
                </Space>
              </Form.Item>
              {/* --No.Identitas */}
              <Form.Item
                label={
                  <span style={{ fontWeight: 'bold' }}>
                    No Identitas Pelajar
                    <span style={{ color: '#FF2020' }}>*</span>
                  </span>
                }
                help={
                  validateIdNumber(idNo) ? (
                    ''
                  ) : (
                    <span style={{ color: '#FF2020', fontSize: '10px' }}>
                      Nomor tidak valid, masukkan format identitas yang benar
                      tanpa mengandung simbol.
                    </span>
                  )
                }
              >
                <Input placeholder="" onChange={e => setIdNo(e.target.value)} />
              </Form.Item>
              {/* --Sekolah/Universitas */}
              <Form.Item
                label={
                  <span style={{ fontWeight: 'bold' }}>
                    Sekolah / Universitas
                    <span style={{ color: '#FF2020' }}>*</span>
                  </span>
                }
                help={
                  validateSchool(schoolName) ? (
                    ''
                  ) : (
                    <span style={{ color: '#FF2020', fontSize: '10px' }}>
                      Sekolah tidak valid. Masukkan format nama sekolah yang
                      benar tanpa mengandung simbol.
                    </span>
                  )
                }
              >
                <Input
                  placeholder=""
                  onChange={e => setSchoolName(e.target.value)}
                />
              </Form.Item>
              {/* --Upload Foto */}
              <Form.Item
                label={
                  <span style={{ fontWeight: 'bold' }}>
                    Unggah Foto Diri (Pelajar) dengan Kartu Pelajar
                    <span style={{ color: '#FF2020' }}>*</span>
                  </span>
                }
              >
                <UploadInput image={image} setImage={setImage} />
              </Form.Item>

              {/* Device */}
              <Form.Item
                label={
                  <span style={{ fontWeight: 'bold' }}>
                    Unit yang tertarik untuk dibeli
                    <span style={{ color: '#FF2020' }}>*</span>
                  </span>
                }
              >
                {/* {listDevice()} */}
                <Select onChange={e => setDevice(e)}>
                  {arrDeviceOptions.map((option, index) => (
                    <Option key={index} value={option}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              {/* --E-Mail */}
              <Form.Item
                label={
                  <span style={{ fontWeight: 'bold' }}>
                    Email
                    <span style={{ color: '#FF2020' }}>*</span>
                  </span>
                }
                help={
                  validateEmail(email) ? (
                    ''
                  ) : (
                    <span style={{ color: '#FF2020', fontSize: '10px' }}>
                      Email tidak valid. Masukkan format email yang benar.
                    </span>
                  )
                }
              >
                {/* Send OTP */}
                <Input.Group compact>
                  <Input
                    style={{ width: 'calc(100% - 120px)' }}
                    onChange={e => setEmail(e.target.value)}
                    max={10}
                  />
                  <Button
                    onClick={onClickSendOtp}
                    disabled={disablingSendOtp}
                    style={{ width: '120px' }}
                  >
                    {isLoadingOtp
                      ? 'Kirim ulang (' + seconds + ')'
                      : 'Kirim OTP'}
                  </Button>
                </Input.Group>
              </Form.Item>
              {/* Submit OTP */}
              <Form.Item
                label={
                  <span style={{ fontWeight: 'bold' }}>
                    Masukkan OTP
                    <span style={{ color: '#FF2020' }}>*</span>
                  </span>
                }
                help={
                  validateOtp(otp) ? (
                    ''
                  ) : (
                    <span style={{ color: '#FF2020', fontSize: '10px' }}>
                      Kode OTP tidak valid. Masukkan 4 angka OTP anda.
                    </span>
                  )
                }
              >
                <Input placeholder="" onChange={e => setOtp(e.target.value)} />
              </Form.Item>
            </div>
            <div className="fieldset" style={{ marginTop: '2em' }}>
              <h1>
                <span>Silakan Konfirmasi kepada Promoter</span>
              </h1>
              {/* Store Code */}
              <Form.Item
                label={
                  <span style={{ fontWeight: 'bold' }}>
                    Masukkan Kode Toko (opsional)
                  </span>
                }
                help={
                  validateStoreCode(storeCode) ? (
                    ''
                  ) : (
                    <span style={{ color: '#FF2020', fontSize: '10px' }}>
                      Format Kode Toko Tidak Valid
                    </span>
                  )
                }
              >
                <Input.Password
                  placeholder=""
                  onChange={e => setStoreCode(e.target.value)}
                />
              </Form.Item>
              {/* ID Promotor */}
              <Form.Item
                label={
                  <span style={{ fontWeight: 'bold' }}>
                    Masukkan ID Promoter (opsional)
                  </span>
                }
                help={
                  validateEcCode(ecCode) ? (
                    ''
                  ) : (
                    <span style={{ color: '#FF2020', fontSize: '10px' }}>
                      Format ID Promoter Tidak Valid.
                    </span>
                  )
                }
              >
                <Input.Password
                  placeholder=""
                  onChange={e => setEcCode(e.target.value)}
                />
              </Form.Item>
            </div>
            <div className="fieldset" style={{ marginTop: '2em' }}>
              <h1>
                <span>Disetujui oleh Pelajar</span>
              </h1>
              {/* Checkbox */}
              <Checkbox.Group
                style={{ width: '100%' }}
                onChange={onChangePrivacy}
              >
                <Checkbox value="B">
                  Dengan ini saya telah membaca, memahami dan menyetujui{' '}
                  <a
                    href="https://www.samsung.com/id/info/privacy/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <u>Kebijakan Privasi</u>
                  </a>{' '}
                  yang berlaku<span style={{ color: '#FF2020' }}>*</span>{' '}
                </Checkbox>{' '}
              </Checkbox.Group>
              {/* Checkbox */}
              <Checkbox.Group
                style={{ width: '100%', marginTop: '20px' }}
                onChange={onChangePromotion}
              >
                <Checkbox value="B">
                  Dengan ini saya setuju untuk menerima promosi dan
                  pemberitahuan oleh Samsung dan afiliasi di kemudian hari
                  (opsional)
                </Checkbox>{' '}
              </Checkbox.Group>
            </div>
            <br />
            <br />
            {/* Kirim Button */}
            <Form.Item style={{ textAlign: 'center' }}>
              <Button
                className="submit-form-button"
                type="primary"
                onClick={onClickSubmit}
                disabled={disablingSubmit}
                loading={isLoadingKirim}
              >
                KIRIM
              </Button>
            </Form.Item>
            <Form.Item style={{ textAlign: 'center' }}>
              <Button
                onClick={onClickContactService}
                style={{ background: 'none', border: 'none' }}
              >
                <p style={{ color: 'grey', textDecoration: 'underline' }}>
                  Contact Service
                </p>
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Row>
    </Fragment>
  );
};

// function Spp() {

//   return (
//     <div
//       style={{
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'center',
//         alignItems: 'center',
//         height: '100%',
//       }}
//     >
//       <span
//         style={{
//           fontFamily: 'Roboto Regular',
//           fontSize: '12px',
//           color: '#505050',
//           marginTop: '12px',
//         }}
//       >
//         Coba Halaman Aa
//       </span>
//     </div>
//   );
// }

export default Spp;
